export function parseError(error: Response | Error | string): string {
  if (error instanceof Response) {
    return error.statusText
  }

  const isProduction = process.env.NODE_ENV === 'production'

  if (error instanceof Error) {
    return isProduction ? error.message : `\n${error.stack}`
  }

  return isProduction ? 'An unknown error occurred.' : error
}

export function delay(delayMilliseconds: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, delayMilliseconds))
}

export enum CsvExportType {
  Standard = 0,
  Cygnet = 1,
}

export enum OwnerType {
  SuperIntendent = 0,
  Foreman = 1,
  Pumper = 2,
}

export enum DrillDownClusterType {
  State = 0,
  Region = 1,
  Owners = 2,
}
